export const germanTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'Startseite',
  'nav.shop': 'Unsere Produkte',
  'nav.about': 'Über uns',
  'nav.contact': 'Kontakt',
  'nav.blog': 'Blog',
  'nav.trackOrder': 'Bestellung verfolgen',

  // Hero
  'hero.badge.pdrn': 'PDRN-Technologie',
  'hero.badge.glassSkin': 'Glass Skin Effekt',
  'hero.badge.korean': 'Koreanische Innovation',
  'hero.title': 'PDRN-Pflege — Koreanisches Lachs-DNA',
  'hero.subtitle': 'Verwandeln Sie Ihre Haut mit klinisch erprobten PDRN-Seren, Tuchmasken und Kapselcremes. Erzielen Sie den Glass Skin Effekt mit unseren Premium-PDRN-Pflegeprodukten auf Lachs-DNA-Basis.',
  'hero.cta': 'Kollektion entdecken',
  'hero.ctaSurvey': 'Kostenlose Hautanalyse',
  'hero.socialProof': 'Geliebt von über 10.000 Pflegebegeisterten',
  'survey.bubbleTooltip': 'Personalisierte Routine + 10% Rabatt',

  // Products
  'products.title': 'Unsere Kollektion',
  'products.subtitle': 'Premium koreanische Pflege mit PDRN-Technologie',
  'products.addToCart': 'In den Warenkorb',
  'products.buyNow': 'Jetzt kaufen',
  'products.soldOut': 'Ausverkauft',
  'products.save': 'Angebot',
  'products.viewDetails': 'Details',
  'products.noProducts': 'Derzeit keine Produkte verfügbar',
  'products.selectSize': 'Größe wählen',
  'products.quantity': 'Menge',
  'products.inStock': 'Auf Lager',
  'products.outOfStock': 'Ausverkauft',

  // Upsell
  'upsell.title': 'Vervollständigen Sie Ihre Routine',
  'upsell.savings': 'Sparen Sie mit dem Komplett-Set',
  'upsell.cta': 'Zum Komplett-Set upgraden',
  'upsell.includes': 'Eine komplette Pflegeroutine in einem Set',
  'upsell.badge': 'Vervollständigen Sie Ihre Routine',
  'upsell.saveBadge': 'Sparen Sie {amount}!',
  'upsell.whyBundle': 'Warum das Komplett-Set wählen?',
  'upsell.whyBundleDesc': 'Jeder Schritt baut auf dem vorherigen auf für maximale Ergebnisse',
  'upsell.includesSerum': 'Rosé-Glow-Serum',
  'upsell.includesCream': 'Intelligente Kapselcreme',
  'upsell.includesMasks': '10er-Pack Masken',
  'upsell.separatelyPrice': 'Einzeln: {amount}',
  'upsell.serumTooltip': 'Leichtes PDRN-Serum, das die Kollagenproduktion fördert, Falten glättet und sofortigen Glass Skin Glow verleiht.',
  'upsell.creamTooltip': 'Innovative Kapselformel mit PDRN, 5% Niacinamid und hydrolysiertem Kollagen für tiefe Feuchtigkeit und Straffheit.',
  'upsell.masksTooltip': '10 Tuchmasken getränkt mit konzentriertem PDRN-Serum für eine Intensivpflege mit sofortigem Glass Skin Effekt.',

  // Cart
  'cart.title': 'Warenkorb',
  'cart.empty': 'Ihr Warenkorb ist leer',
  'cart.itemCount': '{count} Artikel im Warenkorb',
  'cart.total': 'Gesamt',
  'cart.checkout': 'Zur Kasse',
  'cart.continueShopping': 'Weiter einkaufen',
  'cart.addedToCart': 'In den Warenkorb gelegt!',
  'cart.couponPlaceholder': 'Rabattcode',
  'cart.applyCoupon': 'Anwenden',
  'cart.couponApplied': 'Rabatt angewendet!',
  'cart.couponError': 'Ungültiger Code',
  'cart.removeCoupon': 'Entfernen',
  'cart.freeShippingUnlocked': 'Kostenloser Versand freigeschaltet!',
  'cart.freeShippingRemaining': 'Noch {amount} bis zum kostenlosen Versand',
  'cart.freeShippingThreshold': 'Kostenloser Versand für Bestellungen über {amount}',
  'cart.completeRoutine': 'Vervollständigen Sie Ihre Routine',
  'cart.bundleSave': 'Sparen Sie {percent}%',
  'cart.quickAdd': 'Hinzufügen',

  'promo.b2g1': '🎁 Lege 3 Artikel in den Warenkorb — 1 davon ist GRATIS!',
  'promo.b2g1Cart': '🎁 2+1 Aktion aktiviert! Bei 3 Artikeln ist 1 GRATIS!',
  'promo.b2g1CartHint': 'Füge noch {count} hinzu für ein GRATIS-Produkt! (3 Artikel nötig)',
  'promo.b2g1Saving': 'Sie sparen {amount} — günstigster Artikel ist GRATIS!',
  'promo.freeItem': '🎁 GRATIS in Aktion',

  // About
  'about.title': 'Über uns',
  'about.subtitle': 'Die Wissenschaft hinter koreanischer Schönheit',
  'about.pdrnTitle': 'Die Wissenschaft der PDRN-Pflege',
  'about.pdrnDescription': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein revolutionärer Inhaltsstoff der koreanischen Hautpflege. Unsere PDRN-Pflegeprodukte fördern die Zellregeneration für einen perfekten Glass Skin Effekt.',
  'about.glassSkinDesc': 'Erzielen Sie den begehrten koreanischen Glass Skin Effekt mit sofortigem Strahlen.',
  'about.hydrationDesc': 'Tiefe Feuchtigkeit, die den ganzen Tag hält, mit klinisch nachgewiesener Feuchtigkeitsbindung.',
  'about.antiAgingDesc': 'Stimulieren Sie auf natürliche Weise die Kollagenproduktion für straffere, jünger aussehende Haut.',

  // Footer
  'footer.copyright': '© 2026 PDRN SKIN. Alle Rechte vorbehalten.',
  'footer.freeShipping': 'Kostenloser Versand ab {amount} (Deutschland)',
  'footer.securePayment': 'Sichere Zahlung',
  'footer.support': '24/7 Support',
  'footer.description': 'Premium koreanische Pflege mit revolutionärer PDRN-Technologie. Erleben Sie den Glass Skin Effekt mit unseren wissenschaftlichen Produkten.',
  'footer.sheetMasks': 'Tuchmasken',
  'footer.serum': 'Serum',
  'footer.cream': 'Creme',
  'footer.bundle': 'Komplett-Set',
  'footer.faq': 'Häufige Fragen',
  'footer.shippingReturns': 'Versand und Rücksendungen',
  'footer.privacyPolicy': 'Datenschutzrichtlinie',
  'footer.termsOfService': 'Allgemeine Geschäftsbedingungen',
  'footer.returnPolicy': 'Rückgaberichtlinie',
  'footer.contactSupport': 'Wir sind für Sie da — bei Fragen, Bestellstatus, Problemen oder Hilfe beim Kauf. Erreichen Sie unseren Kundenservice unter',

  // Common
  'common.verified': 'Verifiziert',
  'common.before': 'Vorher',
  'common.after': 'Nachher',
  'common.loading': 'Laden...',
  'common.error': 'Ein Fehler ist aufgetreten',
  'common.noPhotoShared': 'Die Kundin hat kein Foto geteilt',

  // Media
  'media.videoPlaceholder': 'Video-Platzhalter',
  'media.gifPlaceholder': 'GIF-Platzhalter',
  'media.imagePlaceholder': 'Bild-Platzhalter',

  // Features
  'feature.hydration': '+100% Feuchtigkeit',
  'feature.glassSkin': 'Glass Skin Effekt',
  'feature.antiAging': 'Anti-Aging',
  'feature.collagen': 'Kollagen-Boost',
  'feature.brightening': 'Aufhellung',

  // Product
  'product.howToUse': 'Anwendung',
  'product.ingredients': 'Wichtige Inhaltsstoffe',
  'product.reviews': 'Kundenbewertungen',
  'product.results': 'Echte Ergebnisse',
  'product.realResults': 'Echte Ergebnisse',
  'product.beforeAfter': 'Vorher und Nachher',
  'product.faqTitle': 'Fragen und Antworten',
  'product.mediaGallery': 'Mediengalerie',
  'product.freeShipping': 'Kostenloser Versand ab {amount}',
  'product.secureCheckout': 'Sichere Zahlung',
  'product.returns': 'Rückgabe innerhalb von 7 Tagen',
  'product.koreanFormula': 'Koreanische Formel',
  'product.premiumIngredients': 'Premium-Inhaltsstoffe',
  'product.backHome': 'Zurück zur Startseite',
  'product.notFound': 'Produkt nicht gefunden',
  'product.bestValue': 'Bestes Preis-Leistungs-Verhältnis',
  'product.bestseller': 'Bestseller',
  'product.reviewCount': '({count} Bewertungen)',
  'product.crueltyFree': 'Nicht an Tieren getestet',
  'product.youMayAlsoLike': 'Das könnte Ihnen auch gefallen',
  'product.completeRoutine': 'Vervollständigen Sie Ihre Pflegeroutine',
  'product.moneyBack': 'Geld-zurück-Garantie innerhalb von 7 Tagen',
  'product.dermatologistTested': 'Dermatologisch getestet',
  'product.payWith': 'Sichere Zahlung über',
  'product.specsTitle': 'Produktdetails',
  'product.specsVolume': 'Größe',
  'product.specsSkinType': 'Hauttyp',
  'product.specsTested': 'Tests',
  'product.specsClinicallyTested': 'Klinisch getestet',
  'product.specsShelfLife': 'Haltbarkeit',
  'product.specsFreeOf': 'Frei von Parabenen, Sulfaten und Phthalaten',
  'product.satisfactionGuarantee': '100% Zufriedenheitsgarantie',
  'product.satisfactionDesc': 'Testen Sie risikofrei mit unserer 7-Tage-Geld-zurück-Garantie',

  // Before After
  'beforeAfter.customer1': 'Lena',
  'beforeAfter.customer2': 'Priya',
  'beforeAfter.customer3': 'Amara',
  'beforeAfter.weeks3': '3 Wochen Anwendung',
  'beforeAfter.weeks8': '8 Wochen Anwendung',
  'beforeAfter.weeks12': '12 Wochen Anwendung',

  // Mobile Cart
  'mobileCart.findRoutine': 'Finden Sie Ihre Routine',

  // Survey
  'survey.buttonText': 'Finden Sie Ihre Routine',
  'survey.title': 'Hautanalyse',
  'survey.subtitle': 'Beantworten Sie einige kurze Fragen und wir empfehlen Ihnen die ideale Routine',
  'survey.question': 'Frage',
  'survey.back': 'Zurück',
  'survey.next': 'Weiter',
  'survey.getResults': 'Ergebnisse anzeigen',
  'survey.resultsTitle': 'Ihre personalisierte Routine',
  'survey.resultsSubtitle': 'Basierend auf Ihren Antworten empfehlen wir Ihnen Folgendes',
  'survey.yourProfile': 'Ihr Hautprofil',
  'survey.recommended': 'Empfohlen für Sie',
  'survey.bundleNote': 'Für die besten Ergebnisse empfehlen wir Ihnen das Komplett-Set',
  'survey.howToUse': 'Ihre personalisierte Routine',
  'survey.morning': 'Morgens',
  'survey.evening': 'Abends',
  'survey.expectedResults': 'Erwartete Ergebnisse',
  'survey.week': 'Woche',
  'survey.weeks': 'Wochen',
  'survey.personalTips': 'Unsere Tipps für Sie',
  'survey.retake': 'Erneut ausfüllen',
  'survey.shopNow': 'Jetzt kaufen',
  'survey.errorTooMany': 'Zu viele Anfragen. Bitte versuchen Sie es später erneut.',
  'survey.errorGeneric': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'survey.yourPersonalizedRoutine': 'Ihre personalisierte Routine',
  'survey.treatmentPlan': 'Empfohlene Behandlungsdauer',
  'survey.addRoutineToCart': 'Routine in den Warenkorb legen',
  'survey.satisfactionGuarantee': '100% Zufriedenheitsgarantie',
  'survey.maybeLater': 'Vielleicht später',
  'survey.continueSurvey': 'Fragebogen fortsetzen',
  'survey.addedToCart': 'Die Produkte wurden in den Warenkorb gelegt!',
  'survey.personalizedRoutine': 'Ihre personalisierte Routine ist bereit',
  'survey.errorAddingToCart': 'Fehler beim Hinzufügen zum Warenkorb',
  'survey.exclusiveDiscount': '10% exklusiver Rabatt für Sie!',
  'survey.couponCopied': 'Gutscheincode kopiert!',
  'survey.useAtCheckout': 'Verwenden Sie den Code SURVEY10 an der Kasse für 10% Rabatt',
  'survey.bestDeal': 'Das beste Angebot, das wir für Sie gefunden haben!',
  'survey.separatePrice': 'Einzeln',
  'survey.yourPrice': 'Ihr Preis',
  'survey.youSave': 'Sie sparen',
  'survey.upgradeOption': 'Möchten Sie noch bessere Ergebnisse?',
  'survey.upgradeToBundle': 'Zum Komplett-Set upgraden',
  'survey.upgradeSave': 'Sparen Sie {amount} mit dem Komplett-Set',
  'survey.addSingleToCart': 'In den Warenkorb',

  // Survey loading messages
  'survey.loading.analyzing': 'Ihr Hautprofil wird analysiert...',
  'survey.loading.planning': 'Eine personalisierte Behandlung wird erstellt...',
  'survey.loading.matching': 'Die perfekten Produkte für Sie werden ausgewählt...',
  'survey.loading.finalizing': 'Fast fertig...',

  // Survey questions
  'survey.q1.question': 'Was ist Ihr Hauttyp?',
  'survey.q1.dry': 'Trocken — meine Haut spannt häufig',
  'survey.q1.oily': 'Fettig — glänzend, besonders an Stirn und Nase',
  'survey.q1.combination': 'Mischhaut — Stirn und Nase fettig, Wangen trocken',
  'survey.q1.normal': 'Normal — ausgeglichen, keine wesentlichen Probleme',
  'survey.q2.question': 'Was stört Sie am meisten an Ihrer Haut?',
  'survey.q2.aging': 'Falten und Mimikfalten',
  'survey.q2.acne': 'Akne und Unreinheiten',
  'survey.q2.dullness': 'Fahler Teint und ungleichmäßiger Hautton',
  'survey.q2.hyperpigmentation': 'Dunkle Flecken und Hyperpigmentierung',
  'survey.q3.question': 'Wie empfindlich ist Ihre Haut?',
  'survey.q3.very': 'Sehr empfindlich — reagiert auf die meisten Produkte',
  'survey.q3.somewhat': 'Etwas empfindlich — gelegentliche Reaktionen',
  'survey.q3.not': 'Nicht empfindlich — verträgt die meisten Produkte',
  'survey.q4.question': 'Wie ist der Feuchtigkeitsgehalt Ihrer Haut?',
  'survey.q4.veryDry': 'Sehr trocken — braucht ständig Feuchtigkeit',
  'survey.q4.somewhatDry': 'Etwas trocken — braucht regelmäßig Feuchtigkeit',
  'survey.q4.balanced': 'Ausgeglichen — weder trocken noch fettig',
  'survey.q4.wellHydrated': 'Gut durchfeuchtet — straff und gesund',
  'survey.q5.question': 'In welcher Altersgruppe sind Sie?',
  'survey.q5.under25': 'Unter 25',
  'survey.q5.25to35': '25-35',
  'survey.q5.35to45': '35-45',
  'survey.q5.over45': 'Über 45',
  'survey.q6.question': 'Wie würden Sie Ihre aktuelle Pflegeroutine beschreiben?',
  'survey.q6.minimal': 'Minimal — nur Reinigung und Feuchtigkeitspflege',
  'survey.q6.basic': 'Einfach — Reinigung, Toner, Feuchtigkeitspflege',
  'survey.q6.moderate': 'Mittel — einschließlich Seren und gezielter Pflege',
  'survey.q6.extensive': 'Umfassend — vollständige koreanische Pflegeroutine',
  'survey.q7.question': 'Wie würden Sie Ihre Hauttextur beschreiben?',
  'survey.q7.smooth': 'Glatt und gleichmäßig',
  'survey.q7.rough': 'Rau und texturiert',
  'survey.q7.uneven': 'Ungleichmäßig mit einigen Unebenheiten',
  'survey.q7.bumpy': 'Hügelig mit sichtbaren Poren',
  'survey.q8.question': 'Was ist Ihr Hauptziel bei der Hautpflege?',
  'survey.q8.glow': 'Den koreanischen Glass Skin Glow erzielen',
  'survey.q8.antiAging': 'Alterserscheinungen reduzieren',
  'survey.q8.hydration': 'Tiefe Feuchtigkeit',
  'survey.q8.all': 'Alles oben Genannte',

  // Trust Strip
  'trust.clinicallyTested': 'Klinisch getestet',
  'trust.happyCustomers': 'Über 10.000 zufriedene Kundinnen',
  'trust.labFormula': 'Koreanische Laborformel',
  'trust.moneyBack': 'Geld-zurück-Garantie in 7 Tagen',

  // Science
  'science.title': 'PDRN aus Lachs-DNA — wissenschaftlich belegt',
  'science.subtitle': 'PDRN ist klinisch erprobt mit peer-reviewten Studien',
  'science.citation1': '„PDRN fördert die Wundheilung und Geweberegeneration durch Aktivierung des Adenosin-A2A-Rezeptors.“',
  'science.source1': '— Journal of Cosmetic Dermatology, 2020',
  'science.citation2': '„PDRN aus Lachs verbessert signifikant die Feuchtigkeit, Elastizität und reduziert die Faltentiefe in klinischen Studien.“',
  'science.source2': '— International Journal of Molecular Sciences, 2021',

  // Science Inside
  'scienceInside.title': 'Die Wissenschaft im Inneren',
  'scienceInside.subtitle': 'Warum diese Formel wirkt — zwei leistungsstarke Motoren in einem Serum',
  'scienceInside.peptides.title': 'Peptide — die Ingenieure',
  'scienceInside.peptides.subtitle': '„Intelligente Botenstoffe, keine Wundercreme“',
  'scienceInside.peptides.point1': 'Kurze Aminosäureketten, die Ihrer Haut signalisieren, sich wie junge, erneuerte Haut zu verhalten',
  'scienceInside.peptides.point2': 'Unterstützen ein strafferes Erscheinungsbild und weniger sichtbare Faltchen im Laufe der Zeit',
  'scienceInside.peptides.point3': 'Stärken die Hautbarriere — die Haut fühlt sich weniger empfindlich und weniger reaktiv an',
  'scienceInside.peptides.point4': 'Intelligenter Effekt, der sich bei regelmäßiger Anwendung verstärkt, kein Eintagswunder',
  'scienceInside.pdrn.title': 'PDRN — der Reparateur',
  'scienceInside.pdrn.subtitle': 'Der führende Reparatur-Inhaltsstoff der K-Beauty-Welt',
  'scienceInside.pdrn.point1': 'DNA-Fragmente, die die Sprache der Regeneration und Reparatur sprechen',
  'scienceInside.pdrn.point2': 'Unterstützt die Hautqualität und fördert ein gesundes, dichtes Erscheinungsbild',
  'scienceInside.pdrn.point3': 'Beruhigt gestresste oder reaktive Haut — weniger Rötungen, mehr Balance',
  'scienceInside.pdrn.point4': 'Im Serum: stetige, intelligente Verbesserung — keine dramatische Veränderung über Nacht',
  'scienceInside.combo.title': 'Zwei Motoren, ein Serum',
  'scienceInside.combo.subtitle': 'Sofortiger Glow + kumulativer Anti-Aging-Effekt',
  'scienceInside.combo.point1': 'Motor 1: „Sofort sichtbar“ — Feuchtigkeit, Lichtstreuung, glattere Textur',
  'scienceInside.combo.point2': 'Motor 2: „Mit der Zeit sichtbar“ — Straffung, Elastizität, Reparatur',
  'scienceInside.combo.point3': 'Der sofortige „Wow“-Effekt motiviert Sie dranzubleiben — die Peptide und PDRN erledigen den Rest',
  'scienceInside.combo.point4': 'Das Ergebnis: dichte, beruhigte und strahlende Haut',
  'scienceInside.tagline': 'Peptide bauen auf und stärken. PDRN repariert und beruhigt. Zusammen schenken sie Ihrer Haut sofortiges Strahlen und langfristige Regeneration.',

  // Science Inside — Default
  'scienceInside.default.subtitle': 'Die Wissenschaft hinter PDRN — wie es Ihre Haut von innen heraus transformiert',
  'scienceInside.default.tagline': 'PDRN aktiviert den natürlichen Reparaturmechanismus der Haut, fördert die Zellregeneration und tiefe Feuchtigkeit ab der ersten Anwendung.',

  // Default product FAQ
  'productContent.default.faq1.q': 'Was ist PDRN und wie wirkt es?',
  'productContent.default.faq1.a': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen. Es aktiviert den natürlichen Reparaturmechanismus der Haut über den Adenosin-A2A-Rezeptor und fördert die Zellregeneration, Kollagenproduktion und tiefe Feuchtigkeit.',
  'productContent.default.faq2.q': 'Ist dieses Produkt für empfindliche Haut geeignet?',
  'productContent.default.faq2.a': 'Ja! Unsere Formeln sind dermatologisch getestet, tierversuchsfrei und frei von Parabenen, Sulfaten und Phthalaten. Sie sind für alle Hauttypen entwickelt, einschließlich empfindlicher Haut.',
  'productContent.default.faq3.q': 'Wie lange dauert es, bis man Ergebnisse sieht?',
  'productContent.default.faq3.a': 'Die meisten Anwenderinnen bemerken verbesserte Feuchtigkeit und sichtbares Strahlen ab der ersten Anwendung. Für optimale Ergebnisse bei feinen Linien und Hauttextur wird eine regelmäßige Anwendung über 4-8 Wochen empfohlen.',

  // Science Inside — Masks
  'scienceInside.masks.subtitle': 'Wie drei leistungsstarke Inhaltsstoffe in jeder Tuchmaske zusammenwirken',
  'scienceInside.masks.tagline': 'PDRN repariert auf Zellebene. Vitamin B12 erhellt. Niacinamid stärkt. 20 Minuten — das ist alles, was Ihre Haut braucht, um alles aufzunehmen.',
  'scienceInside.masks.card1.title': 'PDRN + Vitamin B12 — das Glow-Duo',
  'scienceInside.masks.card1.subtitle': 'Zellreparatur trifft sichtbares Strahlen',
  'scienceInside.masks.card1.point1': 'PDRN aktiviert die Zellregeneration, während Vitamin B12 einen sofortigen Aufhellungseffekt bietet',
  'scienceInside.masks.card1.point2': 'Zusammen bekämpfen sie fahle Haut an der Ursache — nicht nur oberflächlicher Glanz',
  'scienceInside.masks.card1.point3': 'B12 ist ein bewährter Hautpflegewirkstoff, der den Hautton langfristig vereinheitlicht',
  'scienceInside.masks.card1.point4': 'Das Duo wirkt synergistisch — PDRN erneuert, B12 erhellt',
  'scienceInside.masks.card2.title': 'Niacinamid — der Barriere-Aufbauer',
  'scienceInside.masks.card2.subtitle': 'Stärkt, gleicht aus, schützt',
  'scienceInside.masks.card2.point1': 'Stärkt die Hautbarriere, um Feuchtigkeit einzuschließen und Reizstoffe fernzuhalten',
  'scienceInside.masks.card2.point2': 'Verkleinert sichtbar die Poren und reguliert überschüssigen Talg',
  'scienceInside.masks.card2.point3': 'Reduziert Rötungen und beruhigt Entzündungen — ideal für empfindliche Haut',
  'scienceInside.masks.card2.point4': 'Wirkt in allen Hautschichten zur Verbesserung von Textur, Teint und Widerstandsfähigkeit',
  'scienceInside.masks.card3.title': 'Der Masken-Effekt — 20 Minuten tiefe Aufnahme',
  'scienceInside.masks.card3.subtitle': 'Warum eine Tuchmaske einem normalen Serum überlegen ist',
  'scienceInside.masks.card3.point1': 'Die Tuchmaske erzeugt eine okklusiv wirkende Umgebung, die Verdunstung verhindert',
  'scienceInside.masks.card3.point2': 'Wirkstoffe werden in höherer Konzentration geliefert als bei täglichen Seren',
  'scienceInside.masks.card3.point3': 'Tiefe Aufnahme — die Inhaltsstoffe dringen dank längerem Hautkontakt tiefer ein',
  'scienceInside.masks.card3.point4': 'Sofortige und sichtbare Ergebnisse: prallere, feuchtere und strahlendere Haut nach nur einer Anwendung',

  // Science Inside — Cream
  'scienceInside.cream.subtitle': 'Drei fortschrittliche Technologien, die nachts wirken, um Ihre Haut zu transformieren',
  'scienceInside.cream.tagline': 'Kollagen baut die Struktur wieder auf. Ceramide schützen die Barriere. Intelligente Kapseln liefern alles über die Nacht — damit Sie mit erneuerter, strafferer Haut aufwachen.',
  'scienceInside.cream.card1.title': 'Hydrolysiertes Kollagen — die Struktur',
  'scienceInside.cream.card1.subtitle': 'Wiederaufbau von innen nach außen',
  'scienceInside.cream.card1.point1': 'In kleine Fragmente zerlegt, die tatsächlich in die Haut eindringen können — nicht nur auf der Oberfläche bleiben',
  'scienceInside.cream.card1.point2': 'Unterstützt die Strukturmatrix der Haut für verbesserte Festigkeit und Elastizität',
  'scienceInside.cream.card1.point3': 'Hilft, das Erscheinungsbild feiner Linien durch Auffüllen von innen zu reduzieren',
  'scienceInside.cream.card1.point4': 'Arbeitet mit der natürlichen Kollagenproduktion Ihrer Haut — Stärkung, kein Ersatz',
  'scienceInside.cream.card2.title': 'Ceramid-Komplex — der Schutzschild',
  'scienceInside.cream.card2.subtitle': 'Der natürliche Schutz Ihrer Haut, verstärkt',
  'scienceInside.cream.card2.point1': 'Ceramide machen 50% der natürlichen Hautbarriere aus — wir ersetzen, was mit dem Alter verloren geht',
  'scienceInside.cream.card2.point2': 'Schließt Feuchtigkeit bis zu 72 Stunden ein — kein Trockenheits- und Spannungsgefühl mehr nachts',
  'scienceInside.cream.card2.point3': 'Schützt vor Umweltschäden: Verschmutzung, trockene Luft, Temperaturschwankungen',
  'scienceInside.cream.card2.point4': 'Stärkt die Barriere, damit andere Wirkstoffe effektiver arbeiten können',
  'scienceInside.cream.card3.title': 'Intelligente Kapseltechnologie — zeitverzögerte Freisetzung',
  'scienceInside.cream.card3.subtitle': 'Wirkstoffe werden die ganze Nacht über geliefert',
  'scienceInside.cream.card3.point1': 'Mikrokapseln zersetzen sich allmählich und setzen Wirkstoffe über 8 Stunden frei',
  'scienceInside.cream.card3.point2': 'Verhindert den Abbau der Inhaltsstoffe — sie bleiben bis zur Freisetzung wirksam',
  'scienceInside.cream.card3.point3': 'Ihre Haut erhält eine stetige Nährstoffversorgung statt einer einzigen Dosis, die nachlässt',
  'scienceInside.cream.card3.point4': 'Wachen Sie mit erneuerter und durchfeuchteter Haut auf — die Kapseln haben gearbeitet, während Sie geschlafen haben',

  // Science Inside — Bundle
  'scienceInside.bundle.subtitle': 'Warum drei Produkte zusammen Ergebnisse liefern, die kein einzelnes Produkt erreichen kann',
  'scienceInside.bundle.tagline': 'Masken reinigen und nähren. Das Serum repariert und erhellt. Die Creme versiegelt alles. Drei Schritte, ein System — 24 Stunden kontinuierliche Hauttransformation.',
  'scienceInside.bundle.card1.title': 'Drei Schritte, ein System',
  'scienceInside.bundle.card1.subtitle': 'Jedes Produkt bereitet die Haut auf den nächsten Schritt vor',
  'scienceInside.bundle.card1.point1': 'Schritt 1: Tuchmasken reinigen gründlich und nähren mit konzentriertem PDRN + Vitamin B12',
  'scienceInside.bundle.card1.point2': 'Schritt 2: Das Serum repariert, strafft und liefert den Glass Skin Effekt',
  'scienceInside.bundle.card1.point3': 'Schritt 3: Die Creme versiegelt alles mit Kollagen, Ceramiden und zeitverzögert freisetzenden Kapseln',
  'scienceInside.bundle.card1.point4': 'Zusammen: eine komplette Routine, bei der jeder Schritt den vorherigen verstärkt',
  'scienceInside.bundle.card2.title': 'Der Synergieeffekt — besser zusammen',
  'scienceInside.bundle.card2.subtitle': 'Kumulative Ergebnisse, die sich mit der Zeit verstärken',
  'scienceInside.bundle.card2.point1': 'Die Verwendung aller drei Produkte erzeugt einen kumulativen Effekt — die Ergebnisse bauen aufeinander auf',
  'scienceInside.bundle.card2.point2': 'PDRN in jedem Schritt bedeutet konstante Zellregeneration während der gesamten Routine',
  'scienceInside.bundle.card2.point3': 'Verschiedene Anwendungsformen (Maske, Serum, Creme) stellen sicher, dass die Wirkstoffe alle Hautschichten erreichen',
  'scienceInside.bundle.card2.point4': 'Kundinnen berichten über deutlich schnellere Ergebnisse mit der kompletten Routine',
  'scienceInside.bundle.card3.title': '24-Stunden-Abdeckung — Tag und Nacht',
  'scienceInside.bundle.card3.subtitle': 'Ihre Haut bleibt nie ohne Schutz',
  'scienceInside.bundle.card3.point1': 'Morgens: Serum unter dem Make-up für Feuchtigkeit, Schutz und Strahlen den ganzen Tag',
  'scienceInside.bundle.card3.point2': 'Abends: Tuchmaske für eine Tiefenreinigung und Nährung (2-3 Mal pro Woche)',
  'scienceInside.bundle.card3.point3': 'Nachts: Creme mit zeitverzögert freisetzenden Kapseln, die während des Schlafs arbeiten',
  'scienceInside.bundle.card3.point4': 'Das Ergebnis: Regeneration rund um die Uhr — Ihre Haut verbessert sich 24/7',

  // What is PDRN
  'whatIsPDRN.title': 'Was ist PDRN?',
  'whatIsPDRN.subtitle': 'Der revolutionäre Inhaltsstoff, der die Welt der Hautpflege verändert — von der Klinik zu Ihnen nach Hause',
  'whatIsPDRN.origin.title': 'Gewonnen aus Lachs-DNA',
  'whatIsPDRN.origin.subtitle': 'Ein bewährter Inhaltsstoff in der ästhetischen Medizin',
  'whatIsPDRN.origin.point1': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken weltweit eingesetzt wird',
  'whatIsPDRN.origin.point1.US': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in den gesamten USA eingesetzt wird',
  'whatIsPDRN.origin.point1.GB': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken im gesamten Vereinigten Königreich eingesetzt wird',
  'whatIsPDRN.origin.point1.AU': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Australien eingesetzt wird',
  'whatIsPDRN.origin.point1.IL': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Israel eingesetzt wird',
  'whatIsPDRN.origin.point1.DE': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Deutschland eingesetzt wird',
  'whatIsPDRN.origin.point1.FR': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Frankreich eingesetzt wird',
  'whatIsPDRN.origin.point1.ES': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Spanien eingesetzt wird',
  'whatIsPDRN.origin.point1.NO': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Norwegen eingesetzt wird',
  'whatIsPDRN.origin.point1.HR': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Kroatien eingesetzt wird',
  'whatIsPDRN.origin.point1.FI': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in ganz Finnland eingesetzt wird',
  'whatIsPDRN.origin.point1.AE': 'PDRN (Polydeoxyribonukleotid) wird aus Lachs-DNA gewonnen — ein biokompatibles Molekül, das in dermatologischen Kliniken in den gesamten VAE eingesetzt wird',
  'whatIsPDRN.origin.point2': 'Gestützt durch klinische Studien mit messbaren Ergebnissen bei Feuchtigkeit und Elastizität',
  'whatIsPDRN.origin.point3': 'Natürliche regenerative Verbindung — ohne synthetische Füllstoffe, ohne aggressive Chemikalien',
  'whatIsPDRN.howItWorks.title': 'Regeneration auf Zellebene',
  'whatIsPDRN.howItWorks.subtitle': 'Wirkt dort, wo andere Produkte nicht hinkommen',
  'whatIsPDRN.howItWorks.point1': 'Aktiviert den Adenosin-A2A-Rezeptor — löst den natürlichen Reparatur- und Regenerationsprozess Ihrer Haut aus',
  'whatIsPDRN.howItWorks.point2': 'Fördert die Kollagen- und Elastinproduktion von innen, nicht nur oberflächliche Feuchtigkeit',
  'whatIsPDRN.howItWorks.point3': 'Reduziert Entzündungen und beruhigt gestresste Haut für eine gesündere, ausgeglichenere Haut',
  'whatIsPDRN.results.title': 'Klinische Ergebnisse bei Ihnen zu Hause',
  'whatIsPDRN.results.subtitle': 'Bis vor Kurzem — nur in Kliniken',
  'whatIsPDRN.results.point1': 'Bis vor Kurzem waren PDRN-Behandlungen nur in exklusiven Dermatologiekliniken zu hohen Preisen verfügbar',
  'whatIsPDRN.results.point2': 'Unsere Formeln liefern denselben Wirkstoff in einem Format für die tägliche Anwendung zu Hause',
  'whatIsPDRN.results.point3': '+100% Verbesserung der Feuchtigkeit klinisch gemessen — sichtbare Verbesserung ab der ersten Anwendung',

  // Proven Results
  'provenResults.title': 'Bewiesene Ergebnisse',
  'provenResults.stat1.value': '+100%',
  'provenResults.stat1.label': 'Verbesserung der Feuchtigkeit',
  'provenResults.stat1.sub': 'Klinisch gemessen',
  'provenResults.stat2.value': '93%',
  'provenResults.stat2.label': 'Glattere Haut',
  'provenResults.stat2.sub': 'Berichtet innerhalb von 4 Wochen',
  'provenResults.stat3.value': '4.9/5',
  'provenResults.stat3.label': 'Kundenbewertung',
  'provenResults.stat3.sub': 'Durchschnitt über alle Produkte',
  'provenResults.stat4.value': '+10.000',
  'provenResults.stat4.label': 'Zufriedene Kundinnen',
  'provenResults.stat4.sub': 'Weltweit',
  'provenResults.stat4.sub.US': 'In den gesamten USA',
  'provenResults.stat4.sub.GB': 'Im gesamten Vereinigten Königreich',
  'provenResults.stat4.sub.AU': 'In ganz Australien',
  'provenResults.stat4.sub.IL': 'In ganz Israel',
  'provenResults.stat4.sub.DE': 'In ganz Deutschland',
  'provenResults.stat4.sub.FR': 'In ganz Frankreich',
  'provenResults.stat4.sub.ES': 'In ganz Spanien',
  'provenResults.stat4.sub.NO': 'In ganz Norwegen',
  'provenResults.stat4.sub.HR': 'In ganz Kroatien',
  'provenResults.stat4.sub.FI': 'In ganz Finnland',
  'provenResults.stat4.sub.AE': 'In den gesamten VAE',

  // Comparison Table
  'comparison.title': 'PDRN vs herkömmliche Pflege',
  'comparison.headerRegular': 'Herkömmliche Pflege',
  'comparison.headerPDRN': 'PDRN SKIN',
  'comparison.row1.criteria': 'Wirkung',
  'comparison.row1.regular': 'Oberflächliche Feuchtigkeit',
  'comparison.row1.pdrn': 'Regeneration auf Zellebene',
  'comparison.row2.criteria': 'Hauptwirkstoff',
  'comparison.row2.regular': 'Generische Peptide',
  'comparison.row2.pdrn': 'PDRN (Lachs-DNA)',
  'comparison.row3.criteria': 'Ergebnisse',
  'comparison.row3.regular': 'Wochen bis sichtbar',
  'comparison.row3.pdrn': 'Sichtbar ab der ersten Anwendung',
  'comparison.row4.criteria': 'Technologie',
  'comparison.row4.regular': 'Standardformeln',
  'comparison.row4.pdrn': 'Technologie auf klinischem Niveau',
  'comparison.row5.criteria': 'Klinischer Nachweis',
  'comparison.row5.regular': 'Marketingaussagen',
  'comparison.row5.pdrn': 'Klinisch getestet +100% Feuchtigkeit',

  // FAQ
  'faq.sectionTitle': 'Häufig gestellte Fragen',

  // 404
  '404.title': 'Seite nicht gefunden',
  '404.subtitle': 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
  '404.backHome': 'Zurück zur Startseite',
  '404.popularProducts': 'Beliebte Produkte',

  // Product disclaimer and shipping
  'product.disclaimer': '*Die Bilder dienen nur zur Veranschaulichung. Die Ergebnisse können je nach Hauttyp und Anwendung von Person zu Person variieren. Dieses Produkt ist nicht zur Diagnose, Behandlung oder Vorbeugung von Erkrankungen bestimmt. Es wird empfohlen, vor der ersten vollständigen Anwendung einen Empfindlichkeitstest an einer verdeckten Stelle durchzuführen. Bei Empfindlichkeit die Anwendung einstellen. Bei schweren Reaktionen einen Arzt aufsuchen. Der Anbieter kann die Verpackung und Form des Produkts von Zeit zu Zeit ändern; das Produkt bleibt dasselbe.',
  'product.shippingMarquee': 'Kostenloser Versand für Bestellungen über {amount} in ganz Deutschland',
  'product.inStockReady': 'Auf Lager und sofort versandbereit',

  // Terms agreement
  'product.termsAgreementBefore': 'Durch das Surfen und Einkaufen auf dieser Website stimmen Sie unseren ',
  'product.termsLink': 'Allgemeinen Geschäftsbedingungen',
  'product.termsAgreementAfter': ' zu',

  // Announcement
  'announcement.freeShipping': '✨ kostenloser Versand für Bestellungen über {amount} in Deutschland',
  'announcement.close': 'Schließen',

  // Urgency
  'urgency.limitedOffer': 'Begrenztes Angebot',
  'urgency.endsIn': 'Endet in',

  // Blog
  'blog.title': 'Blog',
  'blog.subtitle': 'Professionelle Pflegeratgeber, PDRN-Wissenschaft und Tipps aus der koreanischen Hautpflege',
  'blog.metaDescription': 'Lesen Sie unsere professionellen Ratgeber zu PDRN-Pflege, Lachs-DNA-Wissenschaft, Glass Skin Routinen und Tipps aus der koreanischen Hautpflege.',
  'blog.readMore': 'Weiterlesen',
  'blog.minRead': 'Min. Lesezeit',
  'blog.badge': 'Wissenschaftlich fundierte Hautpflege',
  'blog.chip.antiAging': 'Anti-Aging',
  'blog.chip.hydration': 'Feuchtigkeit',
  'blog.chip.sensitiveSkin': 'Empfindliche Haut',
  'blog.chip.nightRoutine': 'Nachtroutine',
  'blog.chip.ingredients': 'Inhaltsstoffe',
  'blog.chip.layering': 'Layering',
  'blog.chip.glassSkin': 'Glass Skin',
  'blog.chip.pdrnScience': 'PDRN-Wissenschaft',
  'blog.relatedArticles': 'Verwandte Artikel',
  'blog.recommendedProducts': 'Empfohlene Produkte',
  'blog.latestArticles': 'Die neuesten Artikel in unserem Blog',
  'blog.latestSubtitle': 'Professionelle PDRN-Pflegeratgeber und Tipps aus der koreanischen Hautpflege',
  'blog.viewAll': 'Alle Artikel ansehen',
  'blog.statsArticles': 'Artikel',
  'blog.statsLanguages': 'Sprachen',
  'blog.statsVersions': 'Übersetzte Versionen',
  'blog.availableIn': 'In 11 Sprachen verfügbar',
  'blog.avgReadTime': 'Ø 5 Min Lesezeit',

  // SEO meta (homepage)
  'seo.homeTitle': 'PDRN Hautpflege | Koreanisches Lachs-DNA Serum, Masken & Creme | Glass Skin',
  'seo.homeDescription': 'PDRN Hautpflege mit koreanischer Lachs-DNA-Technologie. PDRN-Serum, Tuchmasken & Kapselcreme für den Glass Skin Effekt. Klinisch getestet mit kostenlosem Versand.',

  // SEO product titles & descriptions
  'seo.productTitle.pink-glow-serum-with-pdrn-peptides': 'PDRN Serum mit Lachs-DNA & Peptiden | PDRN Hautpflege',
  'seo.productDescription.pink-glow-serum-with-pdrn-peptides': 'PDRN-Serum mit Lachs-DNA und Peptiden kaufen. Koreanisches Glass Skin Serum für Kollagenaufbau, Faltenglättung und sofortigen Glow. PDRN Hautpflege mit kostenlosem Versand.',
  'seo.productTitle.pdrn-pink-sheet-masks-10-pack': 'PDRN Tuchmasken 10er-Pack | Koreanische Lachs-DNA Masken | PDRN Hautpflege',
  'seo.productDescription.pdrn-pink-sheet-masks-10-pack': 'PDRN-Tuchmasken getränkt mit Lachs-DNA-Serum kaufen. 10 koreanische Gesichtsmasken für den Glass Skin Effekt mit PDRN, Vitamin B12 & Niacinamid.',
  'seo.productTitle.smart-capsule-cream-with-collagen': 'PDRN Kapselcreme mit Kollagen | Koreanische Hautpflege | PDRN Hautpflege',
  'seo.productDescription.smart-capsule-cream-with-collagen': 'PDRN-Kapselcreme mit Kollagen und Niacinamid kaufen. Koreanische Anti-Aging-Creme mit Lachs-DNA-Technologie für tiefe Feuchtigkeit und Straffheit.',
  'seo.productTitle.complete-pdrn-trio-bundle': 'Komplettes PDRN Hautpflege-Set — Serum, Masken & Creme | PDRN Hautpflege',
  'seo.productDescription.complete-pdrn-trio-bundle': 'Das komplette PDRN-Hautpflege-Set mit Serum, 10 Tuchmasken & Kapselcreme kaufen. Bis zu 53% sparen bei koreanischer Lachs-DNA-Pflege.',

  // Internal linking
  'seo.explorePDRN': 'PDRN Hautpflege entdecken',
  'seo.anchor.serumBenefits': 'Vorteile des PDRN-Serums',
  'seo.anchor.howPDRNWorks': 'Wie PDRN wirkt',
  'seo.anchor.masksVsTraditional': 'PDRN-Masken vs. herkömmliche',
  'seo.anchor.glassSkinGuide': 'Glass Skin Anleitung',
  'seo.anchor.koreanSecret': 'Koreanisches Pflegegeheimnis',
  'seo.anchor.pdrnVsRegular': 'PDRN vs. herkömmliche Pflege',
};
